import { Controller } from "stimulus";
import BootstrapNavTabs from "../entrypoints/src/admin/components/bootstrap_nav_bars";

export default class extends Controller {
  connect() {
    BootstrapNavTabs.mergeCustomFeatures(this.element.querySelector('.tr-nav'));

    this.navLinkCommission = this.element.querySelector('.nav-link#commissions');
    if (this.navLinkCommission) {
      this.navLinkCommission.addEventListener('click', (ev) => this.loadCommissionsFrame());
      this.navLinkCommission.classList.contains('active') && this.loadCommissionsFrame();
    }

    this.navLinkFinancial = this.element.querySelector('.nav-link#financial');
    if (this.navLinkFinancial) {
      this.navLinkFinancial.addEventListener('click', (ev) => this.loadFinancialFrame());
      this.navLinkFinancial.classList.contains('active') && this.loadFinancialFrame();
    }
  }

  loadCommissionsFrame() {
    if (!!this.navLinkCommission.dataset.clicked) return;

    this.navLinkCommission.dataset.clicked = 'true';
    document.querySelector('#turbo-frame__professor-commissions').setAttribute('src', this.navLinkCommission.dataset.src);
  }

  loadFinancialFrame() {
    if (!!this.navLinkFinancial.dataset.clicked) return;

    this.navLinkFinancial.dataset.clicked = 'true';
    document.querySelector('#turbo-frame__professor-financial').setAttribute('src', this.navLinkFinancial.dataset.src);
  }
};
